module.exports = __webpack_public_path__ + "static/img/Jarome-Luai.c0dd049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarome-Luai.jpg
// module id = 6RNz
// module chunks = 0